import React, { useState } from 'react';
import './ReferralForm.css';

function ReferralForm({ onSubmit, company }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    resume: null,
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      resume: e.target.files[0]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="referral-form">
      <h2>Enter Your Details</h2>
      <h3>Applying to {company.name}</h3>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Full Name"
            required
          />
        </div>
        
        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            required
          />
        </div>
        
        <div className="form-group">
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Your Phone Number"
            required
          />
        </div>
        
        <div className="form-group">
          <label className="file-input-label">
            Upload Resume (PDF)
            <input
              type="file"
              accept=".pdf"
              onChange={handleFileChange}
              required
            />
          </label>
        </div>
        
        <div className="form-group">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Any additional information you'd like to share"
          ></textarea>
        </div>
        
        <button type="submit" className="submit-button">
          Submit Referral Request
        </button>
      </form>
    </div>
  );
}

export default ReferralForm; 